import {UISprite} from "./Tools/Base/UISprite";
import {Core} from "../Base/Core";

export class UIAttention extends UISprite {

    constructor(updateFn = null) {
        super("alert");
        this.SetActive(false);
        this.updateFn = updateFn;
    }

    Update() {
        if (this.Active) return;
        if (this.updateFn) {
            this.SetActive(this.updateFn());
        }
    }

    fitRect(rect, fill = false) {
        // Fix the size for all instances in game
        let size = Core.app.viewport.width * 0.04;
        this.scale.set(Math.min(
            size / this.texture.width,
            size / this.texture.height
        ));
        this.position.set(
            rect.x + rect.width * this.anchor.x,
            rect.y + rect.height * this.anchor.y
        );
    }

    fitLayout(rect) {
        return this.fitRect(rect);
    }
}
